export const rangePresent = (range?: null | { min?: unknown; max?: unknown }) =>
  !!range?.min || !!range?.max
